import React, { useState } from 'react';
import PropTypes from 'prop-types';

import CaretDown from '@decisiv/iconix/lib/components/CaretDown';
import CaretUp from '@decisiv/iconix/lib/components/CaretUp';
import UserPlus from '@decisiv/iconix/lib/components/UserPlus';
import UsersGroup from '@decisiv/iconix/lib/components/UsersGroup';

import OptionsList from '@decisiv/ui-components/lib/atoms/OptionsList';
import Popover from '@decisiv/ui-components/lib/components/Popover';

import { CreateUserTrigger } from './styles';

export const CREATE_USER_ID = 'create-user';

// Creating one user is PD-4064; creating several is still to come, so that option
// stays disabled and the menu keeps matching the mockup.
const ITEMS = [
  {
    id: CREATE_USER_ID,
    label: 'Create User',
    decoration: { type: 'Icon', icon: UserPlus },
  },
  {
    id: 'create-multiple-users',
    label: 'Create Multiple Users',
    disabled: true,
    decoration: { type: 'Icon', icon: UsersGroup },
  },
];

/**
 * The CREATE USER split button: a filled trigger that opens the two creation
 * options.
 *
 * A styled button rather than the KeyDS Button because the mockup has an icon on
 * both sides of the label and Button only renders one. Same approach as
 * ManagementLayout/AppsLinks, which styles its own trigger for the same reason.
 */
function CreateUserButton({ onCreateUser }) {
  const [isOpen, setIsOpen] = useState(false);
  const Caret = isOpen ? CaretUp : CaretDown;

  // Single-select, so OptionsList reports one id rather than an array. The menu is
  // a pair of commands rather than a selection, hence selectable={false}: the id
  // is dispatched and nothing stays checked.
  const handleChange = (id) => {
    setIsOpen(false);
    if (id === CREATE_USER_ID) onCreateUser();
  };

  return (
    <Popover
      hideOnClickOutside
      onRequestHide={() => setIsOpen(false)}
      placement="bottom-start"
      showArrow={false}
      visible={isOpen}
      target={
        <CreateUserTrigger
          type="button"
          $active={isOpen}
          aria-expanded={isOpen}
          onClick={() => setIsOpen((open) => !open)}
        >
          <UserPlus size="small" />
          Create User
          <Caret size="small" />
        </CreateUserTrigger>
      }
    >
      <OptionsList
        items={ITEMS}
        // OptionsList defaults pointerEvents to "none", which leaves the rows
        // unclickable.
        pointerEvents="auto"
        selectable={false}
        onChange={handleChange}
      />
    </Popover>
  );
}

CreateUserButton.propTypes = {
  onCreateUser: PropTypes.func.isRequired,
};

export default CreateUserButton;
